import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsDeleteRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-delete',
	path: '(/secure/|/)project/DeleteProject([!%]?[\\w]*).jspa',
	query: ['pid'],
};
